module.exports = __webpack_public_path__ + "img/watermark.a3d666e9.png";